export { getNowStreamingProjects, getAllMovies, getAllShows } from './NowStreamingService'
export type { NowStreamingContent } from './NowStreamingService'
